/**
 * Admin — Feedback page — /admin/feedback
 *
 * SYSTEM_ADMIN only. See AdminNav for the full list of admin sections.
 */
import React from 'react';
import { FeedbackPanel } from '@/components/admin/FeedbackPanel';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminFeedbackPage: React.FC = () => (
  <AdminPageShell title="Feedback" sysAdminOnly>
    <FeedbackPanel />
  </AdminPageShell>
);
